<template>
	<div class="body">
		<!-- 原内容区域 -->


		<!-- AI聊天助手区域 -->
		<div class="ai-chat-section">
			<div class="chat-header">
				<h3>职教数AI职业顾问</h3>
				<el-button 
					size="small" 
					@click="toggleChat" 
					:icon="chatExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'">
					{{ chatExpanded ? '收起' : '展开' }}
				</el-button>
			</div>

			<el-collapse-transition>
				<div v-show="chatExpanded" class="chat-container">
					<!-- 聊天消息区域 -->
					<div class="chat-messages" ref="chatMessagesRef">
						<div v-for="(message, index) in chatMessages" :key="index" 
							:class="['message-item', message.role]">
							<div class="avatar">
								<el-avatar :size="32">
									<span v-if="message.role === 'user'">👤</span>
									<span v-else>🤖</span>
								</el-avatar>
							</div>
							<div class="message-content">
								<div class="message-role">
									{{ message.role === 'user' ? '你' : '职教数AI顾问' }}
									<span class="timestamp">
										{{ formatTime(message.timestamp) }}
									</span>
								</div>
								<div class="message-text">
									<div v-if="message.role === 'assistant' && message.isStreaming">
										{{ message.content }}
										<span class="streaming-cursor">▋</span>
									</div>
									<div v-else>
										{{ message.content }}
									</div>
								</div>
							</div>
						</div>

						<!-- 加载状态 -->
						<div v-if="isGenerating" class="message-item assistant">
							<div class="avatar">
								<el-avatar :size="32">🤖</el-avatar>
							</div>
							<div class="message-content">
								<div class="message-role">职教数AI顾问</div>
								<div class="message-text">
									<div class="thinking">
										<span class="dot">.</span>
										<span class="dot">.</span>
										<span class="dot">.</span>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- 输入区域 -->
					<div class="chat-input">
						<el-input
							v-model="chatInput"
							type="textarea"
							:rows="5"
							placeholder="请输入关于职业选择的问题..."
							:disabled="isGenerating"
							@keydown.enter.exact.prevent="sendChatMessage"
							@keydown.enter.shift.exact.prevent="chatInput += '\n'"
						/>

						<div class="input-actions">
							<div class="quick-questions">
								<el-tag
									v-for="(question, qIndex) in quickQuestions"
									:key="qIndex"
									size="small"
									@click="useQuickQuestion(question)"
									class="quick-question-tag"
								>
									{{ question }}
								</el-tag>
							</div>

							<div class="action-buttons">
								<el-button 
									v-if="isGenerating"
									type="danger" 
									size="small"
									@click="stopGenerating"
									icon="el-icon-close"
								>
									停止生成
								</el-button>

								<el-button 
									v-if="chatMessages.length > 2"
									type="info" 
									size="small"
									@click="clearChat"
									icon="el-icon-delete"
								>
									清空对话
								</el-button>

								<el-button 
									type="primary" 
									:loading="isGenerating"
									:disabled="!chatInput.trim()"
									@click="sendChatMessage"
									icon="el-icon-s-promotion"
								>
									{{ isGenerating ? '生成中...' : '发送' }}
								</el-button>
							</div>
						</div>
					</div>
				</div>
			</el-collapse-transition>
		</div>

		<!-- 职业详情对话框 -->
		<el-dialog
			:visible.sync="showCareerDialog"
			title="职业详情"
			width="600px"
		>
			<div v-if="careerData" class="career-detail">
				<h4>{{ careerData.careerName }}</h4>
				<el-descriptions :column="2" border>
					<el-descriptions-item label="行业大类">{{ careerData.industryMajor }}</el-descriptions-item>
					<el-descriptions-item label="匹配度">{{ careerData.matchScore }}</el-descriptions-item>
					<el-descriptions-item label="薪资范围">{{ careerData.salaryRange }}</el-descriptions-item>
					<el-descriptions-item label="需求趋势">{{ careerData.demandTrend }}</el-descriptions-item>
				</el-descriptions>
				<div class="career-description">
					<h5>职业描述</h5>
					<p>{{ careerData.description }}</p>
				</div>
				<div class="career-skills">
					<h5>所需技能</h5>
					<el-tag
						v-for="(skill, sIndex) in careerData.skills"
						:key="sIndex"
						type="info"
						size="small"
						class="skill-tag"
					>
						{{ skill }}
					</el-tag>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		calcuGroupIndustryCareer
	} from "@/api/matrix"
	import aiChatService from '@/utils/aiChat'

	export default {
		name: "Famous",
		data() {
			return {
				title: '',
				list: [],
				spanMap: {},
				params: {
					page: 1,
					pageSize: 20
				},
				total: 0,
				careerData: {},
				showCareerDialog: false,
				acceptMap: {},

				// AI聊天相关数据
				chatExpanded: true,
				chatMessages: [],
				chatInput: '',
				isGenerating: false,
				currentEventSource: null,
				quickQuestions: [
					'根据我的分析结果，推荐最适合我的3个职业',
					'这些职业的发展前景如何？',
					'我需要学习哪些技能来胜任这些职业？',
					'这些职业的平均薪资是多少？',
					'请分析我的优势和不足'
				]
			}
		},
		created() {
			this.initPageData();
			// 初始化AI聊天消息
			this.initChatMessages();
		},
		beforeDestroy() {
			// 清理资源
			if (this.currentEventSource) {
				this.currentEventSource.close();
			}
			aiChatService.cancelRequest();
		},
		methods: {
			initPageData() {
				this.requestData();
			},

			requestData() {
				// this.groupId = this.$route.query.id;
				// this.codes = this.$route.query.codes;
				// this.params['group_id'] = this.groupId;
				// this.params['codes'] = this.codes;
				// calcuGroupIndustryCareer(this.params).then(res => {
				// 	console.log('groupId', this.groupId)
				// 	let realData = res.data;
				// 	this.list = realData.list;
				// 	this.total = realData.pageData.totalCount;
				// 	this.spanMap = this.getSpanMap(this.list, ['industryMajor']);
					
				// 	// 根据分析结果生成初始AI建议
				// 	this.generateInitialAISuggestion();
				// });
				
				this.generateInitialAISuggestion();
			},

			// 初始化聊天消息
			initChatMessages() {
				this.chatMessages = [{
					role: 'assistant',
					content: '您好！我是AI职业顾问。我可以根据帮你回答你的问题',
					timestamp: Date.now(),
					isStreaming: false
				}];
			},

			// 生成初始AI建议
			generateInitialAISuggestion() {
				const topCareers = this.list.slice(0, 3);
				const suggestion = ` 天空为什么是蓝色`;
				
				this.chatMessages.push({
					role: 'assistant',
					content: suggestion,
					timestamp: Date.now(),
					isStreaming: false
				});
			},

			// 切换聊天窗口
			toggleChat() {
				this.chatExpanded = !this.chatExpanded;
				if (this.chatExpanded) {
					this.$nextTick(() => {
						this.scrollToBottom();
					});
				}
			},

			// 发送聊天消息
			async sendChatMessage() {
				const text = this.chatInput.trim();
				if (!text || this.isGenerating) return;

				// 添加用户消息
				const userMessage = {
					role: 'user',
					content: text,
					timestamp: Date.now(),
					isStreaming: false
				};
				this.chatMessages.push(userMessage);
				this.chatInput = '';

				// 添加AI消息占位符
				const aiMessage = {
					role: 'assistant',
					content: '',
					timestamp: Date.now(),
					isStreaming: true
				};
				this.chatMessages.push(aiMessage);

				// 滚动到底部
				this.scrollToBottom();

				// 开始流式对话
				this.isGenerating = true;

				try {
					// 准备对话历史
					const conversationHistory = this.chatMessages
						.filter(msg => !msg.isStreaming)
						.map(msg => ({ role: msg.role, content: msg.content }));

					// 添加上下文信息（职业分析结果）
					const contextMessage = {
						role: 'system',
						content: `### 回答规则 ###
1. 禁止按语义分段输出，必须一次性返回完整回答，无论内容包含多少个知识点；
2. 禁止主动暂停输出，无需等待用户发送“继续”指令；
3. 回答需完整覆盖所有知识点，不要拆分，不要遗漏任何部分；
4. 输出格式：连续文本，不要分段、不要分批次返回。`
					};

					// 使用流式对话
					await aiChatService.streamChat(
						[contextMessage, ...conversationHistory],
						{
							model: 'doubao-pro',
							temperature: 0.7,
						},
						{
							onMessage: (chunk) => {
								// 更新AI消息内容
								const lastMessage = this.chatMessages[this.chatMessages.length - 1];
								if (lastMessage.role === 'assistant') {
									// this.$set(lastMessage, 'content', chunk.full_content);
									this.$set(lastMessage, 'content', lastMessage.content + chunk.content);
								}

								// 滚动到底部
								this.scrollToBottom();
							},

							onComplete: (data) => {
								console.log('对话完成:', data);
							},

							onError: (error) => {
								this.$message.error('请求失败: ' + error);
								
								// 更新最后一条消息为错误状态
								const lastMessage = this.chatMessages[this.chatMessages.length - 1];
								if (lastMessage.role === 'assistant') {
									lastMessage.content = '抱歉，我遇到了一些问题。错误信息: ' + error;
									lastMessage.isStreaming = false;
								}
							},

							onDone: () => {
								// 完成处理
								const lastMessage = this.chatMessages[this.chatMessages.length - 1];
								if (lastMessage.role === 'assistant') {
									lastMessage.isStreaming = false;
									lastMessage.timestamp = Date.now();
								}

								this.isGenerating = false;
								this.scrollToBottom();
							},
						}
					);

				} catch (error) {
					console.error('对话异常:', error);
					this.$message.error('请求异常: ' + error.message);
					
					// 恢复状态
					const lastMessage = this.chatMessages[this.chatMessages.length - 1];
					if (lastMessage.role === 'assistant') {
						lastMessage.content = '抱歉，请求出现异常: ' + error.message;
						lastMessage.isStreaming = false;
					}
					
					this.isGenerating = false;
				}
			},

			// 使用快速问题
			useQuickQuestion(question) {
				this.chatInput = question;
			},

			// 停止生成
			stopGenerating() {
				aiChatService.cancelRequest();
				this.isGenerating = false;
				
				const lastMessage = this.chatMessages[this.chatMessages.length - 1];
				if (lastMessage.role === 'assistant') {
					lastMessage.content += '\n\n[已停止生成]';
					lastMessage.isStreaming = false;
				}
			},

			// 清空对话
			clearChat() {
				this.$confirm('确定要清空对话记录吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.chatMessages = [{
						role: 'assistant',
						content: '对话已清空。请问您需要什么帮助？',
						timestamp: Date.now(),
						isStreaming: false
					}];
					this.generateInitialAISuggestion();
				});
			},

			// 滚动到底部
			scrollToBottom() {
				this.$nextTick(() => {
					const container = this.$refs.chatMessagesRef;
					if (container) {
						container.scrollTop = container.scrollHeight;
					}
				});
			},

			// 格式化时间
			formatTime(timestamp) {
				if (!timestamp) return '';
				const date = new Date(timestamp);
				return `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
			},

			// 获取合并单元格的映射（原有的getSpanMap函数）
			getSpanMap(data, mergeFields) {
				const spanMap = {};
				if (!data || data.length === 0) return spanMap;

				let pos = 0;
				for (let i = 0; i < data.length; i++) {
					if (i === 0) {
						spanMap[i] = [1, 1];
						pos = 0;
					} else {
						let isSame = true;
						for (const field of mergeFields) {
							if (data[i][field] !== data[i - 1][field]) {
								isSame = false;
								break;
							}
						}

						if (isSame) {
							spanMap[pos][0] += 1;
							spanMap[pos][1] = 0;
							spanMap[i] = [0, 0];
						} else {
							spanMap[i] = [1, 1];
							pos = i;
						}
					}
				}
				return spanMap;
			},

			// 查看职业详情
			viewCareerDetail(career) {
				this.careerData = career;
				this.showCareerDialog = true;
			}
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "mobile.scss" as *;
	@use "industry_career.scss";


	.body {
		display: flex;
		flex-direction: column;
		gap: 20px;
		padding: 20px;
	}

	.original-content {
		background: white;
		border-radius: 8px;
		padding: 20px;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
	}

	.ai-chat-section {
		background: white;
		border-radius: 8px;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
		overflow: hidden;
		width: 1260px;

		.chat-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 16px 20px;
			border-bottom: 1px solid #ebeef5;
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
			color: white;

			h3 {
				margin: 0;
				font-size: 16px;
				font-weight: 600;
			}
		}

		.chat-container {
			display: flex;
			flex-direction: column;
			max-height: 800px;
			height: 80%;
			width: 1260rpx;
		}

		.chat-messages {
			flex: 1;
			padding: 20px;
			overflow-y: auto;
			background: #f8f9fa;

			.message-item {
				display: flex;
				margin-bottom: 16px;
				animation: fadeIn 0.3s ease;

				&.user {
					flex-direction: row-reverse;

					.message-content {
						margin-right: 12px;
						margin-left: 0;
						align-items: flex-end;
					}

					.message-text {
						background: #1890ff;
						color: white;
						border-radius: 12px 12px 0 12px;
					}
				}

				&.assistant {
					.message-content {
						margin-left: 12px;
						margin-right: 0;
						align-items: flex-start;
					}

					.message-text {
						background: white;
						color: #333;
						border-radius: 12px 12px 12px 0;
						box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
					}
				}
			}

			.avatar {
				flex-shrink: 0;
			}

			.message-content {
				flex: 1;
				display: flex;
				flex-direction: column;
				max-width: 70%;
			}

			.message-role {
				font-size: 12px;
				color: #666;
				margin-bottom: 4px;
				display: flex;
				justify-content: space-between;
				align-items: center;

				.timestamp {
					font-size: 11px;
					opacity: 0.7;
				}
			}

			.message-text {
				padding: 12px 16px;
				line-height: 1.6;
				word-break: break-word;
				white-space: pre-wrap;

				.streaming-cursor {
					animation: blink 1s infinite;
					color: #1890ff;
				}
			}

			.thinking {
				padding: 8px 0;

				.dot {
					display: inline-block;
					animation: bounce 1.4s infinite;

					&:nth-child(2) {
						animation-delay: 0.2s;
					}

					&:nth-child(3) {
						animation-delay: 0.4s;
					}
				}
			}
		}

		.chat-input {
			border-top: 1px solid #ebeef5;
			padding: 16px;
			background: white;

			.input-actions {
				display: flex;
				flex-direction: column;
				gap: 12px;
				margin-top: 12px;
			}

			.quick-questions {
				display: flex;
				flex-wrap: wrap;
				gap: 8px;

				.quick-question-tag {
					cursor: pointer;
					transition: all 0.3s;

					&:hover {
						transform: translateY(-2px);
						box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
					}
				}
			}

			.action-buttons {
				display: flex;
				justify-content: flex-end;
				gap: 8px;
			}
		}
	}

	.career-detail {
		h4 {
			margin-top: 0;
			color: #303133;
		}

		.career-description {
			margin: 16px 0;
			padding: 12px;
			background: #f5f7fa;
			border-radius: 4px;

			h5 {
				margin: 0 0 8px 0;
				color: #606266;
			}
		}

		.career-skills {
			h5 {
				margin: 16px 0 8px 0;
				color: #606266;
			}

			.skill-tag {
				margin-right: 8px;
				margin-bottom: 8px;
			}
		}
	}

	@keyframes fadeIn {
		from {
			opacity: 0;
			transform: translateY(10px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	@keyframes blink {
		0%, 100% {
			opacity: 1;
		}
		50% {
			opacity: 0;
		}
	}

	@keyframes bounce {
		0%, 80%, 100% {
			transform: translateY(0);
		}
		40% {
			transform: translateY(-10px);
		}
	}

	/* 响应式调整 */
	@media (max-width: 768px) {
		.body {
			padding: 10px;
			gap: 10px;
		}

		.ai-chat-section {
			.chat-container {
				height: 400px;
			}

			.chat-messages {
				padding: 10px;

				.message-content {
					max-width: 85%;
				}
			}
		}
	}
</style>